<template>
  <section class="login">
    <b-container>
      <b-row>
        <b-col cols="12" md="8" offset-md="2" lg="4" offset-lg="4">
          <div class="login_form box">
            <h3>Вход</h3>
            <form @submit.prevent="loginHandler">
              <input type="email" placeholder="Email" v-model.trim="loginData.email">
              <input type="password" placeholder="Пароль" v-model.trim="loginData.password">
              <transition name="fade-slideUp">
                <p class="login_wrong error" v-if="loginData.wrongData">Неправильный логин или пароль</p>
              </transition>
              <input class="btn btn__succes" type="submit" value="Войти">
            </form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
'use strict';
export default {
  data: () => ({
    loginData: {
      email: '',
      password: '',
      wrongData: false
    }
  }),
  methods: {
    async loginHandler() {
      const formData = {
        email: this.loginData.email,
        password: this.loginData.password
      }

      try {
        await this.$store.dispatch("login", formData);
        this.$router.push('/admin')
      } catch (error) {
        this.loginData.wrongData = true;
      }
    }
  }
};
</script>

<style lang='sass'>
.login
  &_form
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    input
      width: 100%
  &_wrong
    text-align: center
    font-weight: bold
</style>